import React, { Component } from "react";
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import InputAdornment from '@material-ui/core/InputAdornment';
//import Grid from '@material-ui/core/Grid';
import cyan from '@material-ui/core/colors/cyan';
import { createMuiTheme, withStyles, makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';


const ColorButton = withStyles(theme => ({
  root: {
    backgroundColor: cyan[500],
    '&:hover': {
      backgroundColor: cyan[700],
    },
	width: "100%",
	fontWeight: "bold",
	fontSize: "12px",
	lineHeight: "12px",
	height: "24px"
  },
}))(Fab);

class Login extends Component {
	constructor (props) {
		super(props);
		this.state = {
			username: '',
			password: '',
//			logedIn: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(e) {
		e.preventDefault();
		this.setState({[e.target.name]: e.target.value });
	}

	handleSubmit(e) {
		e.preventDefault();
		this.props.login(this.state.username, this.state.password);
	}

	render() {
		const { t } = this.props;
		return (
			<div className="d-flex align-items-center justify-content-center">
			<div className="login">
				<form 
					action={this.props.action}
					method={this.props.method}
					onSubmit={this.onSubmit}
				>
				
				<div class="form-group">
					<TextField
						id="username"
						name="username"
						label={t('user_name')}
						defaultValue=""
						margin="normal"
						InputLabelProps={{style: { color: '#fff', fontFamily: "'Lato', sans-serif", fontSize: '16px' }}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
								<span style={{ fontFamily: "tipoecl", fontSize: "21px"}}>&#59402;</span>
								</InputAdornment>
							),
							style: {color : "white", borderBottom: '1px dotted white', fontFamily: "'Lato', sans-serif", fontSize: '16px' },
						}}
						onChange={this.handleChange}
					/>
				</div>
				
				<div class="form-group">
				<TextField
					id="password"
					name="password"
					label={t('password')}
					defaultValue=""
					margin="normal"
					type="password"
					autoComplete="current-password"
					InputLabelProps={{style: { color: '#fff' }}}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
							<span style={{ fontFamily: "tipoecl", fontSize: "21px"}}>&#59403;</span>
							</InputAdornment>
						),
						style: {color : "white", borderBottom: '1px dotted white'},
					}}
//					variant="outlined"
					onChange={this.handleChange}
				/>
				</div>
				<ColorButton variant="extended" aria-label="Login" onClick={this.handleSubmit.bind(this)}>
					Login
				</ColorButton>
				</form>
			</div>
			</div>
		);
	}
}
export default withTranslation()(Login);